import { Modal } from "@msys/ui";
import React from "react";
import { useTranslate } from "@tolgee/react";
import { MyOrganisationUserEditForm } from "./MyOrganisationUserEditForm.js";
import { Link } from "react-router-dom";

interface Props {
  userId: string;
  handleClose: () => void;
}

export const MyOrganisationUserEditModal = ({ userId, handleClose }: Props) => {
  const { t } = useTranslate(["UserProfile", "Global"]);
  return (
    <Modal
      handleClose={handleClose}
      title={t("Edit organisation user profile", { ns: "UserProfile" })}
      actionButtons={[
        {
          label: t("Go to user profile page", { ns: "UserProfile" }),
          buttonProps: {
            variant: "text",
            component: Link,
            // @ts-ignore
            to: `/organisation/users/${userId}`,
          },
        },
      ]}
    >
      <MyOrganisationUserEditForm userId={userId} />
    </Modal>
  );
};
